import type { UiActionParameters } from './ui-action'

import { createWatch } from 'effector'
import { SnapshotMap } from '../../general/snapshot-map'
import { $openFrom } from '../models/routes'

const SNAPSHOTS_TO_KEEP = 0

export const parameters = new SnapshotMap<UiActionParameters>(
  SNAPSHOTS_TO_KEEP,
  [
    ['featureIdentifier', 'playback_actions'],
    ['uiElementType', 'recommendations_row'],
    ['uiElementName', 'recommendations_shown'],
    ['actionName', 'show'],
  ]
)

function fromOpenFrom(openFrom: string) {
  parameters //
    .update('route', openFrom)
    .commit()
    .notify()
}

createWatch({
  unit: $openFrom,
  fn: fromOpenFrom,
})
